import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import './App.css'; // Import the CSS file
import { useLocation } from 'react-router-dom';

const ContactUsPage = () => {

const cardData = [
  {
    img: './images/travel.webp',
    title: 'Custom Travel Planning',
    text: 'Our team is expertise in designing your travel itineraries and planning the best for you.'
  },
  {
    img: './images/exper.png',
    title: 'Experience & Qualifications',
    text: 'We have a team with more than 10 years of experience & Qualifications in the field.'
  },
  {
    img: './images/helping.webp',
    title: 'Exceptional Customer care & Integrity',
    text: 'We are always responsive and supportive in assisting customer inquiries and we maintain the highest confidentiality regarding all of your information.'
  },
  {
    img: './images/guid.jpg',
    title: 'National Tour Guide Services',
    text: 'Wasala Tours ensures a smooth journey with expert guides fluent in English, Sinhalese and also can provide other language speaking guides as per your request for authentic travel experience.'
  },
  {
    img: './images/transport.webp',
    title: 'Transport Services',
    text: 'We prioritize your comfort and safety with reliable vehicles and skilled drivers. Special transport like helicopters, sea planes, and super luxury vehicles is available on request for a premium experience.'
  }
];


  return (
   <div
     className="contact-page-wrapper"
     id="contact"
     style={{
       backgroundImage: "linear-gradient(to right, rgba(255,255,255,0.6) 30%, rgba(255,255,255,0.8) 60%, rgba(255,255,255,1) 100%), url('./images/nature.png')",
       backgroundSize: "cover",

       backgroundRepeat: "no-repeat",
       color: "black",
       minHeight: "100vh",
       padding: "2rem",
       display: "flex",
       flexDirection: "column",
       justifyContent: "center",
     }}
   >

      {/* First Row - Main Heading */}
      <div className="contact-header-container">
     <div className="contact-heading">
         <img src="./images/ST7.jpeg"  className="heading-image" />
         <img src="./images/Photo/ST1.jpeg" className="heading-image" />

</div>

      {/* Second Row - Description */}
      <div className="contact-description">

            <div className="contact-heads">
               <h1><span className="highlight-span1"> Wasala Tours</span><br/>Charting Remarkable Expeditions  <br/><span className="highlight-span">  Since 2014 </span> </h1>
       </div>
        <p>
          Wasala Tours (Pvt) Ltd is a proudly Sri Lankan tourism company founded in 2014 by two passionate and dedicated young entrepreneurs. What began as a small-scale venture has steadily grown over the years, officially becoming a registered private limited company in 2018.
          Today, Wasala Tours stands as a trusted name in the travel and hospitality industry of Sri Lanka. <br /><br />
          With a strong focus on delivering exceptional hospitality services, we specialize in creating unforgettable travel experiences tailored to individual preferences. Our offerings include customized tour packages, comfortable transportation,
                            hotel bookings, and a variety of adventure and cultural excursions across the island.<br/><br />

                                  We are committed to ensuring that our guests feel welcomed and well taken care of throughout their journey. To support a diverse clientele, we offer services in multiple languages, including English and Chinese, helping us bridge cultural gaps and enhance the travel experience for international visitors.

                                  Whether you're seeking relaxation, adventure, or cultural immersion,
                                   Wasala Tours is your reliable partner in discovering the beauty
                                   and heritage of Sri Lanka.
                                </p>
      </div>

      </div>

      <div className="why-choose-container">
        <div className="why-left">
          <h2>Why Choose Wasala Tours</h2>
          <p>
            See how we've helped travelers design meaningful and unforgettable journeys across Sri Lanka.
          </p>
        </div>

        <div className="why-right">
          {cardData.map((card, index) => (
            <div key={index} className="why-card">
              <img src={card.img} className="why-icon" />
              <div className="card-titles">
                <h3>{card.title}</h3>
              </div>
              <p>{card.text}</p>
            </div>
          ))}
        </div>
      </div>



    </div>
  );
};

export default ContactUsPage;
